module.exports = __webpack_public_path__ + "static/media/coin-icon.9f93ef49.svg";